import React from 'react';
import { ProjectTitle } from './styles';

const ProjectName = ({ project }) =>
  (
    <ProjectTitle>
      {project.title}
    </ProjectTitle>
  );

export default ProjectName;
